<template>
  <div :class="['post', { 'post-best': postBest }]">
    <el-card class="box-card post-card">
      <div slot="header" class="clearfix" v-if="type == 'topic'">
        <el-row class="header">
          <div class="header-data hidden-sm-and-down">
            查看：<span class="text-red">{{ values.readNum }}</span> 回复：<span
              class="text-red"
              >{{ values.replyNum }}</span
            >
          </div>
          <el-col
            :xs="24"
            :sm="24"
            :md="20"
            :lg="20"
            :xl="20"
            class="header-title"
          >
            <el-tag
              type="warning"
              size="mini"
              v-if="values.postType && values.postType === 'file'"
              style="margin-right: 5px"
              >寻找文件</el-tag
            >
            <el-tag
              type="primary"
              size="mini"
              v-if="values.postType && values.postType === 'question'"
              style="margin-right: 5px"
              >技术问答</el-tag
            >

            <h1 class="seoH1Title">{{ values.title }}</h1>
          </el-col>
        </el-row>
      </div>

      <el-row class="info">
        <div class="info-nickname hidden-sm-and-down">
          <router-link
            :to="
              values.user && values.user.id ? `/u/${values.user.id}` : '/u/0'
            "
          >
            <span class="text-wch text-bold"> {{ values.user.nickname }}</span>
          </router-link>
        </div>
        <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="info-ext">
          <div class="info-create">
            <router-link
              :to="
                values.user && values.user.id ? `/u/${values.user.id}` : '/u/0'
              "
              class="hidden-sm-and-up text-wch"
            >
              {{ values.user.nickname }}
            </router-link>

            发表于：{{ $dayjs(values.createTime).fromNow() }}
          </div>
          <div class="info-tool">
            <!-- 更多操作 -->
            <MoreButtons v-if="hasPermission" :reverse="true" :showNum="0" trigger="click">
              <Authorized permission="POST/DELETE">
                <a @click=" onDeleteTopicPost(values.id, values.forumId, values.replyId)">删除</a>
              </Authorized>
              <Authorized permission="POST/EDIT">
                <a class="btn" @click="handleEdit(values.id, values.replyId)">编辑</a>
              </Authorized>
              <Authorized permission="POST/TOP">
                <a class="btn" v-if="type == 'topic' && (values.top == 0 || !values.top)" @click="postTop(values.id)">置顶</a>
              </Authorized>
              <Authorized permission="POST/TOP">
                <a class="btn" v-if="type == 'topic' && values.top == 1" @click="postCancelTop(values.id)">取消置顶</a>
              </Authorized>
              <Authorized permission="POST/SEDIMENT">
                <a class="btn" v-if="type == 'topic' && (!values.status)" @click="setSediment(values.id)">沉底</a>
              </Authorized>
              <Authorized permission="POST/SEDIMENT">
                <a class="btn" v-if="type == 'topic' && values.status && values.status === 'DOWN'" @click="cancelSediment(values.id)">取消沉底</a>
              </Authorized>
            </MoreButtons> 
            <p class="hidden-sm-and-down">{{ floor }}#</p>
          </div>
        </el-col>
      </el-row>
      <el-row class="content">
        <div class="content-user hidden-sm-and-down">
          <UserAvatar :size="120" :user="values.user" />
          <div style="margin-top: 15px" v-if="user && Object.keys(user).length > 0">
            <a @click="showPm(values.user)" class="text-highlinght">
              <i class="el-icon-message"></i>
              站内信
            </a>
          </div>

          <div data-v-5dd7a102="" style="margin-top: 15px;" v-if="values.user">
            <!-- 工程师 -->
            <img v-if="values.user.employee" src="@/assets/employeeUser.png" style="height:40px">
            <!-- 活跃用户 -->
            <img v-else-if="values.user.postStatus && values.user.postStatus == 'ACTIVE'" src="@/assets/activeUser.png" style="height:40px">
            <!-- 认证用户 -->
            <img v-else-if="values.user.phoneVerifyStatus && values.user.phoneVerifyStatus == '1'" src="@/assets/certifyUser.png" style="height:40px">
          </div>

          <div class="content-user-data">
            <div class="content-user-value">
              <span class="text-highlinght">{{
                values.user && values.user.postNum != null
                  ? values.user.postNum
                  : "-"
              }}</span>
            </div>
            <div class="content-user-value">
              <span class="text-highlinght">{{
                values.user && values.user.replyNum != null
                  ? values.user.replyNum
                  : "-"
              }}</span>
            </div>
            <div class="content-user-value">
              <!-- 这里给判断一下,积分超过9999的显示奖牌的图片 -->
              <img v-if="values.user && values.user.exp && values.user.exp > 9999" src="@/assets/medal.gif" style="height:20px">
              <span v-else class="text-highlinght">{{ values.user && values.user.exp ? values.user.exp : "-" }}</span>
            </div>
            <div class="content-user-value">主题</div>
            <div class="content-user-value">回复</div>
            <div class="content-user-value">积分</div>
          </div>
        </div>
        <el-col
          :xs="24"
          :sm="24"
          :md="20"
          :lg="20"
          :xl="20"
          class="content-value"
        >
          <el-tag
            type="success"
            v-if="values.status && values.status === 'BEST'"
            style="margin: 15px; font-weight: 600"
            ><i class="el-icon-check"></i> 已采纳</el-tag
          >
          <div class="product-tag-card">
            <el-tag
              type="primary"
              v-for="i in values.tags"
              :key="i"
              class="product-tag"
              >{{ i }}</el-tag
            >
          </div>

          <div class="content-value-html" v-html="postContent" @click="handleContentClick"></div>

          <Authorized permission="POST/MAIL">
            <div class="email-container" v-if="values.email">
              <el-card shadow="hover" class="email-card">
                <div class="card-header">
                  <UserAvatar
                    :size="30"
                    :user="values.user"
                    :shape="circle"
                    style="margin-right: 5px"
                  />

                  <div class="site-name">{{ values.user.nickname }}</div>
                </div>

                <div class="email-address text-highlinght">
                  <span
                    @click="onCopy()"
                    class="email-address-value"
                    :data-clipboard-text="values.email"
                    >{{ values.email }}</span
                  >
                </div>
                <!-- <p class="description">客户求助邮箱,点击上方邮箱复制</p> -->
              </el-card>
            </div>
          </Authorized>

          <div class="user-btn">
            <a
              class="btn"
              v-if="
                user &&
                values.user &&
                values.user.id == user.id &&
                type == 'topic'
              "
              @click="handleUserEdit(values.id)"
            >
              <el-button type="primary" plain size="mini" icon="el-icon-edit"
                >编辑</el-button
              >
            </a>
            <a
              class="btn"
              v-if="user && values.user && !currentPostId && user.postStatus != 'CLOSED'"
              @click="handleUserComment(values.id, null)"
            >
              <el-button
                type="success"
                plain
                size="mini"
                icon="el-icon-chat-line-round"
                >评论</el-button
              >
            </a>
            <a
              class="btn"
              v-if="user && values.user && currentPostId"
              @click="handleHideComment(values.id)"
            >
              <el-button
                type="success"
                plain
                size="mini"
                icon="el-icon-chat-line-round"
                >关闭评论框</el-button
              >
            </a>
          </div>
          <transition name="fade">
            <Editor
              v-if="currentPostId"
              btn="评论"
              :values="{ height: '100px' }"
              :height="100"
              type="post_comment"
              :currentId="currentPostId"
              :currentUser="currentPostUser"
              @hideComment="handleHideComment"
            />
          </transition>

          <ul class="comments">
            <li v-for="comment in comments" :key="comment.id">
              <div class="comment-content">
                <UserAvatar :size="20" :user="comment.user" />

                <router-link :to="'/u/' + comment.user.id" class="nickname"
                  >{{ comment.user.nickname }} :</router-link
                >

                <div v-if="comment.commentToUser">
                  <span> 回复 </span>
                  <router-link
                    :to="'/u/' + comment.commentToUser.id"
                    class="nickname"
                  >
                    {{ comment.commentToUser.nickname }}
                  </router-link>
                </div>

                <div v-html="comment.content"></div>
              </div>
              <div class="comment-tool">
                <span class="time">
                  {{ $dayjs(comment.createTime).fromNow() }}
                </span>

                <el-tooltip
                  class="item"
                  effect="dark"
                  content="回复"
                  placement="top-start"
                >
                  <i
                    class="el-icon-chat-dot-round"
                    v-if="
                      user &&
                      values.user &&
                      !currentPostId &&
                      comment.userId != user.id && 
                       user.postStatus != 'CLOSED'
                    "
                    @click="handleUserComment(values.id, comment.user)"
                  ></i>
                </el-tooltip>
              </div>
            </li>
          </ul>

          <SignatureAd v-if="type == 'topic'" />

          <div
            class="user-btn"
            v-if="
              type != 'topic' &&
              topic &&
              topic.postType == 'question' &&
              (!values.status || values.status != 'BEST')
            "
          >
            <a
              class="btn"
              v-if="user && topic && topic.userId && topic.userId == user.id"
              @click="handleBest(values.id, values.replyId)"
            >
              <el-button type="success" icon="el-icon-magic-stick"
                >这个回答有用 , 点击采纳 !!</el-button
              >
            </a>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog
      title="站内信"
      :visible.sync="pmDialogVisible"
      width="30%"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
      <div class="input">
        <div
          style="margin-bottom: 15px; text-align: left; font-size: 16px"
          class="text-highlinght"
        >
          to: {{ currentUser ? currentUser.nickname : "-" }}
        </div>

        <el-input
          type="textarea"
          :rows="5"
          placeholder="文明发言，手有余香，营销内容或有害信息会导致封号"
          v-model="input"
        >
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="margin-top: 5px" @click="handleSave"
          >发送</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteTopicPost,
  deleteReplyPost,
  postTop,
  postCancelTop,
  setBestAnswer,
  getComments,
  setSediment,
  cancelSediment
} from "@/service/post";
import { savePmCotent } from "@/service/user";
import { mapGetters } from "vuex";
import UserAvatar from "@/components/UserAvatar";
import Authorized from "@/components/Authorized";
import MoreButtons from '@/components/MoreButtons';
import SignatureAd from "@/components/SignatureAd";
import Clipboard from "clipboard";
import Editor from "@/components/Editor";
//import Prism from "prismjs/components/prism-core"; // 引入 Prism.js
import Prism from "prismjs";
import "prismjs/themes/prism.css"; // 引入你喜欢的主题
import { can } from "@/utils/permissions";
export default {
  props: {
    values: {
      required: true,
      default: {},
    },
    topic: {
      default: null,
    },
    type: {
      required: true,
      default: "topic",
    },
    floor: {
      required: true,
      default: 1,
    },
    currentPage: {
      required: true,
      default: 1,
    },
  },
  data() {
    return {
      currentPostUser: null,
      list: null,
      comments: [],
      listLoading: true,
      total: 0,
      pageSize: 10,
      input: "",
      pmDialogVisible: false,
      currentUser: null,
      currentPostId: null,
      // currentPage: 1,
    };
  },

  components: {
    UserAvatar,
    Authorized,
    SignatureAd,
    Editor,
    MoreButtons
  },
  created() {
    this.comments = this.values.comment;
    // console.info(this.values)
    // console.info(this.topic)
    // console.info(this.values.replyId)
  },
  computed: {
    ...mapGetters(["user"]),
    postContent() {
      // /<span\s+data-w-e-type="mention"\s+data-w-e-is-void\s+data-w-e-is-inline\s+data-value="([^"]*)"\s+data-info="([^"]*)">(@[^<]+)<\/span>/g,
      // 后端会补全html为="",前台兼容下  20250529
      return this.values.content.replace(
        /<span\s+data-w-e-type="mention"\s+data-w-e-is-void(?:="")?\s+data-w-e-is-inline(?:="")?\s+data-value="([^"]*)"\s+data-info="([^"]*)">(@[^<]+)<\/span>/g,
        '<a href="u/$2" class="mention">$3</a>'
      );
    },
    postBest() {
      return this.values.status && this.values.status === "BEST";
    },
    // 获取权限
    hasPermission() {
      if(this.user){
        const forumAdmin = this.user.forumAdmin ? this.user.forumAdmin : false;
        if (forumAdmin) {
          // 是管理员
          return true;
        }
        // 这几个权限中有一个即可
        const userPermissions = this.user.perms;
        if(can("POST/DELETE", userPermissions) || can("POST/EDIT", userPermissions) || can("POST/TOP", userPermissions) || can("POST/SEDIMENT", userPermissions)){
          return true;
        }
        return false;
      }
      return false;
    },
  },
  mounted() {
    // 初始化 Prism.js
    //设置行号

    Prism.highlightAll();
  },
  methods: {
    handleContentClick(event) {
      // 检查点击的是否是图片（或图片的子元素）
      const img = event.target.closest('img');
      if (img && !img.src.includes('icon_rar.gif')) {
        // 阻止事件冒泡，避免触发多层处理
        event.stopPropagation();
        // 获取图片 URL 并触发预览
        const imageUrl = img.src;
        console.log('=======================点击的是图片',imageUrl)
        // 像父组件传值
        this.$emit('image-clicked', imageUrl);
      }
    },
    onCopy() {
      let clipboard = new Clipboard(".email-address-value");
      clipboard.on("success", (e) => {
        this.$message({
          message: e.text + "  复制成功",
          type: "success",
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        //console.error("Action:", e.action);
        // console.error("Trigger:", e.trigger);
        //  console.info("Text:", e.text);
        this.$message({
          message: "复制失败",
          type: "error",
        });
        // 释放内存
        clipboard.destroy();
      });
    },

    showPm(user) {
      this.currentUser = user;
      this.pmDialogVisible = true;
    },
    handleSave() {
      // this.loading = true;
      savePmCotent({
        to: this.currentUser.id,
        content: this.input,
      }).then((res) => {
        //     this.loading = false;
        if (res.code == 0) {
          this.input = "";
          this.$message.success("发送成功");
          this.currentUser = null;
          this.pmDialogVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onDeleteTopicPost(id, forumId, replyId) {
      if (replyId == 0) {
        deleteTopicPost(id)
          .then((response) => {
            const { code, data, message } = response;
            if (code == 0) {
              this.$message.success(message);
              this.$router.push(`forum-${forumId}-1.html`);
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        deleteReplyPost(id)
          .then((response) => {
            const { code, data, message } = response;
            if (code == 0) {
              this.$message.success(message);
              this.$router.push(
                `/thread-${replyId}-1.html?time=` +
                  this.$dayjs().format("YYYYMMDDHHmmssSSS")
              );
            } else {
              this.$message.error(message);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    handleEdit(id, replyId) {
      if (replyId == 0) {
        this.$router.push(`/topic_edit?id=` + id);
      } else {
        this.$router.push(
          `/reply_edit?id=` + id + `&current_page=` + this.currentPage
        );
      }
    },
    handleBest(id, replyId) {
      this.$confirm("确认采纳了吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setBestAnswer({
            postId: id,
          }).then((res) => {
            if (res.code === 0) {
              this.$message.success("采纳成功");

              this.$router.push(
                `/thread-` +
                  replyId +
                  `-1.html?time=` +
                  this.$dayjs().format("YYYYMMDDHHmmssSSS")
              );
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: "info",
            message: "已取消采纳",
          });
        });
    },
    handleUserEdit(id) {
      this.$router.push(`/topic_update?id=` + id);
    },
    handleUserComment(id, user) {
      this.currentPostId = id;
      this.currentPostUser = user;
    },
    handleHideComment() {
      getComments({ postId: this.currentPostId }).then((res) => {
        if (res.code == 0) {
          this.comments = res.data;
          this.currentPostId = null;
        }
      });
    },
    setSediment(id) {
      setSediment(id)
        .then((response) => {
          const { code, data, message } = response;
          if (code == 0) {
            this.$message.success(message);
            this.$router.push(`/thread-` + id + `-1.html?time=` + this.$dayjs().format("YYYYMMDDHHmmssSSS"));
          } else {
            this.$message.error(message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    cancelSediment(id) {
      cancelSediment(id)
        .then((response) => {
          const { code, data, message } = response;
          if (code == 0) {
            this.$message.success(message);
            this.$router.push(`/thread-` + id + `-1.html?time=` + this.$dayjs().format("YYYYMMDDHHmmssSSS"));
          } else {
            this.$message.error(message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    postTop(id) {
      postTop(id)
        .then((response) => {
          const { code, data, message } = response;
          if (code == 0) {
            this.$message.success(message);
            this.$router.push(
              `/thread-` +
                id +
                `-1.html?time=` +
                this.$dayjs().format("YYYYMMDDHHmmssSSS")
            );
          } else {
            this.$message.error(message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    postCancelTop(id) {
      postCancelTop(id)
        .then((response) => {
          const { code, data, message } = response;
          if (code == 0) {
            this.$message.success(message);
            this.$router.push(
              `/thread-` +
                id +
                `-1.html?time=` +
                this.$dayjs().format("YYYYMMDDHHmmssSSS")
            );
          } else {
            this.$message.error(message);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="less">
.comments {
  li {
    list-style: none;

    .comment-content {
      display: flex;
      line-height: 20px;
      height: 20px;
      p {
        margin: 0 !important;
      }
      .nickname {
        margin-left: 5px;
        font-size: 14px !important;
        margin-right: 5px;
      }
      a {
        color: #1483dc !important;
      }
    }
    .comment-tool {
      color: #1483dc !important;
      display: block;
      padding-left: 25px;
      margin-bottom: 5px;
      margin-top: 5px;
      span {
        color: #666;
        font-size: 12px;
        font-weight: 400;
        margin-right: 10px;
      }
    }
  }
}
.post-best {
  border: 5px solid #85ce61 !important;
}
.post {
  background-color: #fff;

  border: 1px solid #969696;
  .el-card {
    margin: 3px;
    background-color: #ebebeb;
    .el-card__header {
      min-height: 30px;
      height: auto !important;
      padding: 0;
      .header {
        display: flex;
        border-bottom: 3px solid #969696;
        .header-data {
          width: 200px;
          border-right: 2px solid #fff;
          line-height: 30px;
          font-size: 12px;
        }
        .header-title {
          font-weight: 700;
          line-height: 30px;
          padding-left: 15px;
          text-align: left;
        }
      }
    }
    .el-card__body {
      padding: 0;
      .info {
        min-height: 38px;
        height: auto !important;
        height: 38px;
        line-height: 38px;
        display: flex;
        .info-nickname {
          width: 200px;
          border-right: 2px solid #fff;
          text-align: center;
        }
        .info-ext {
          // width: 80%;
          display: flex;
          .info-create {
            padding-left: 15px;
            width: 200px;
            text-align: left;

            //超出部分省略号

            a {
              display: inline-block;
              max-width: 80px;
              height: 14px;
              line-height: 14px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .info-tool {
            text-align: right;
            width: 100%;
            ul {
              padding: 0;
              margin: 0;
              li {
                margin-right: 5px;
                list-style: none;
                float: right;
              }
              li.btn {
                color: #00428b;
                font-weight: 700;
                cursor: pointer;
              }
            }
          }
        }
      }
      .content {
        border-top: 1px dashed #969696;
        min-height: 200px;
        height: auto !important;
        height: 200px;
        border-bottom: 2px solid #ffffff;
        display: flex;
        .content-user {
          width: 200px;
          border-right: 2px solid #fff;
          text-align: center;
          padding-top: 20px;
          .content-user-data {
            width: 120px;
            margin: 10px auto;
            .content-user-value {
              margin-top: 10px;
              width: 40px;
              float: left;
              text-align: center;
            }
          }
        }
        .content-value {
          text-align: left;
          // width: 80%;
          .content-value-html {
            margin: 20px;
            min-height: 300px;
          }
          img {
            max-width: 600px;
            display: block;
            margin-bottom: 10px;
            margin-top: 10px;
            border: 1px solid #ddd;
            -webkit-box-shadow: 0 0 30px #ccc;
            box-shadow: 0 0 30px #ccc;
            cursor: pointer;
          }
          .user-btn {
            margin: 20px;
            margin-top: 10px;
            padding-top: 5px;

            min-height: 20px;
            height: auto !important;
            font-size: 12px;
            margin-bottom: 20px;
            .btn {
              margin-right: 10px;
            }
          }
          .ad {
            margin: 20px;
            margin-top: 10px;
            padding-top: 5px;
            border-top: 1px solid #969696;
            min-height: 40px;
            height: auto !important;
            font-size: 12px;
            margin-bottom: 20px;
          }
          .comments {
            img {
              margin: 0;
            }
          }
          .email-container {
            width: 100%;
            padding: 20px;

            .site-name {
              font-size: 18px;
              color: #6c757d;
            }

            .el-card__header {
              border: none !important;
            }

            .email-card {
              .card-header {
                display: flex;
                align-items: center;

                margin-bottom: 5px;
              }
              img {
                margin: 0 !important;
              }
              .email-address {
                font-size: 20px;
                font-weight: 600;

                margin-bottom: 8px;
                span {
                  cursor: pointer;
                }
              }

              .description {
                font-size: 14px;
                color: #666;
                margin: 0;
              }

              background-color: white;
              border-radius: 16px;
              width: 250px;
              padding: 15px;
            }
          }
          //padding: 20px;
        }
      }
    }
  }
}

.forum-card {
  //border: 1px solid #969696 !important;

  .el-card__header {
    padding: 0;

    .header {
      height: 30px;
      background-color: #1483dc;
      border-radius: 0px;
      padding: 0px;
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
    }

    .tool {
      height: 20px;
      background-color: #e1dfdf;
      color: #00428b;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      padding-left: 20px;
      padding-right: 20px;
      .forum-item-ext-post-num {
        margin: 0;
      }
      .forum-item-ext-reply-num {
        margin: 0;
      }
      .forum-item-ext-reply {
        margin: 0;
      }
    }
    a {
      font-size: 14px;
      font-weight: bold;

      line-height: 30px;
      color: #ebebeb;
      display: block;
      float: left;
    }
  }

  margin-bottom: 20px;
}

.forum-item {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #969696;
  min-height: 80px;
  display: flex;

  &:last-child {
    border-bottom: none !important;
  }
}
// .forum-item-value {
//   display: flex;
//   width: 80%;
//   .el-avatar {
//     background-color: #fff;
//     margin-top: 15px;
//   }
//   .forum-item-name {
//     margin-left: 10px;

//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     text-align: left;
//     .forum-item-ext-reply {
//       line-height: 1;
//     }
//   }
// }
.forum-item-ext {
  width: 300px;
  display: flex;
  //justify-content: flex-end;
  .forum-item-ext-post-num {
    text-align: left;
    width: 50px;
    margin-top: 20px;
  }
  .forum-item-ext-reply-num {
    width: 50px;
    margin-top: 20px;
    text-align: left;
  }
  .forum-item-ext-reply {
    text-align: right;
    margin-top: 20px;
    margin-left: 15px;

    .forum-item-ext-reply-time {
      margin-top: 5px;
    }
  }
}

.seoH1Title {
  font-size: 14px;
  margin: 0;
  display: inline-block;
}

// pre[class*="language-"] {
//   max-width: 600px;
// }

</style>
